import superagent from 'superagent'

// A layer's legend, fetched when its info popover first opens and kept per layer id for
// the session. Resolves with the Layer/Legend item, or null when the layer has none. A
// failed fetch isn't cached, so opening the popover again retries.

const cache = new Map()

export const clearLayerLegendCache = () => cache.clear()

export const fetchLayerLegend = layerId => (dispatch, getState) => {
  if (cache.has(layerId)) return cache.get(layerId)
  const token = getState().auth && getState().auth.token
  const request = superagent
    .get(`${__API_URI_2__}/Layer/Legend`)
    .query({ layerIds: layerId })
    .set('Authorization', `Bearer ${token}`)
    .set('Platform', 'Web')
    .set('Version', `${__version__}`)
    .then(res => (Array.isArray(res.body) ? res.body.find(l => l.layerId === layerId) : null) || null)
    .catch(err => {
      cache.delete(layerId)
      throw err
    })
  cache.set(layerId, request)
  return request
}
